import { Controller } from "@hotwired/stimulus";

// Shows only the standards panel for the nation chosen in the select.
// All panels are rendered server-side; inactive ones are made `inert` (which
// removes them from the accessibility tree, blocks focus, and disables
// pointer events) and visually hidden via the BEM modifier class. CSS keeps
// the panels stacked in a single grid cell, so the wrapper is always as tall
// as the tallest panel and switching nations never resizes the surrounding
// card.
export default class extends Controller {
  static targets = ["select", "panel"];

  connect() {
    this.showSelectedPanel();
  }

  change() {
    this.showSelectedPanel();
  }

  showSelectedPanel() {
    const selected = this.selectTarget.value;

    this.panelTargets.forEach((panel) => {
      const isSelected = panel.dataset.nationCode === selected;
      panel.classList.toggle("standards-nation-panel--hidden", !isSelected);
      panel.inert = !isSelected;
    });
  }
}
